













import { Component, Mixins } from "vue-property-decorator";
import mixins from "@/mixins";
import AssetItem from "trade/components/qutation/AssetItem.vue";

@Component({
  components: {
    AssetItem
  }
})
class QuotationPage extends Mixins(mixins.page, mixins.processOrders) {
  expandAsset = "";

  needAuth = false;

  get title() {
    return this.$t("common.buy-sell") as string;
  }

  get bottomNav() {
    return "buy_sell";
  }

  get appbar() {
    return {
      back: false
    };
  }

  get assets() {
    const offers = this.$store.state.trade.fiatPairs;
    return offers;
  }

  mounted() {
    this.$store.dispatch("trade/loadData");
  }

  handleExpand(asset) {
    if (this.expandAsset === asset) {
      this.expandAsset = "";
      return;
    }
    this.expandAsset = asset;
  }
}
export default QuotationPage;
